import type FormHandler from './FormHandler';
import IFormPostHandler from './IFormPostHandler';
import ValidationService from './ValidationService';

export default class DefaultFormPostHandler implements IFormPostHandler {
  formHandler: FormHandler;

  constructor(formHandler: FormHandler) {
    this.formHandler = formHandler;
  }

  async post() {
    const results = await ValidationService.validateForm(this.formHandler.formDataRetriever.getFormData());

    return {
      validationResult: results,
    };
  }
}
